// Email helpers shared by the auth modal (login with email) and the settings
// "add email" flow. Deliberately permissive — the server stays the real
// authority on what a valid, deliverable address is. This only catches typos
// before we spend a round trip.

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

// Fallback for when the email endpoints cannot be reached or fail unexpectedly.
// Deliberately says nothing about why: users get an action they can take, not our
// deployment state or a status code.
export const EMAIL_AUTH_UNAVAILABLE_MESSAGE =
    "Email sign-in isn't available right now. Please sign in with your phone number.";

export function normalizeEmail(value) {
    return String(value || '').trim().toLowerCase();
}

export function getEmailValidationError(value) {
    const email = normalizeEmail(value);
    if (!email) return 'Please enter your email address.';
    if (email.length > 254) return 'That email address is too long.';
    if (!EMAIL_PATTERN.test(email)) return 'Enter a valid email address.';
    return null;
}

export function getEmailAuthErrorMessage(response, data, fallback) {
    if ([404, 405, 501].includes(response?.status)) {
        return EMAIL_AUTH_UNAVAILABLE_MESSAGE;
    }
    return data?.detail || data?.error || fallback;
}
